import React, { Component } from 'react'
import { Box } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Atr from './Atr';

class AtrHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusView: 'inprogress',
      atrRenderKey: 0
    };
  }

  handleStatusViewChange = (statusView) => {
    this.setState(prevState => ({
      statusView,
      atrRenderKey: prevState.atrRenderKey + 1
    }));
  }

  render() {
    return (
      <Box>
        <Box display='flex' justifyContent='center' alignItems={'center'} m={1}>
          <ToggleButtonGroup
            value={this.state.statusView}
            exclusive
            size='small'
          >
            <ToggleButton value='inprogress' onClick={() => this.handleStatusViewChange('inprogress')}>Inprogess</ToggleButton>
            <ToggleButton value='completed' onClick={() => this.handleStatusViewChange('completed')}>Completed</ToggleButton>
          </ToggleButtonGroup>
        </Box>
        {this.state.statusView ? <Atr key={`${this.state.statusView}-${this.state.atrRenderKey}`} status={this.state.statusView} /> : null}
      </Box>
    )
  }
}

export default AtrHome;
